export type ContentType = "news" | "article" | "editorial" | "vidya" | "njayar";

export const CONTENT_TYPE_LABELS: Record<ContentType, string> = {
  news: "News",
  article: "Today's Article",
  editorial: "Editorial",
  vidya: "Vidya Prabhaadham",
  njayar: "Njayar Prabhaadham",
};

// All possible form field keys
export type FormField =
  | "heading"
  | "title"
  | "body"
  | "blurb"
  | "author"
  | "image1"
  | "image2"
  | "socialImage"
  | "authorImage"
  | "image1Caption"
  | "image1Description"
  | "image2Description"
  | "image3Description"
  | "audio"
  | "permalink"
  | "tags"
  | "tagString"
  | "categories"
  | "subcategories"
  | "njayarCategory"
  | "seriesName"
  | "isHighPriority"
  | "isSecondLeads"
  | "isSecondPriority"
  | "isThirdPriority"
  | "onlive"
  | "scheduled_at"
  | "metaTitle"
  | "metaDescription"
  | "socialEmbed"
  | "embedType"
  | "masterid";

export interface FieldVisibility {
  visible: FormField[];
  required: FormField[];
}

export const FIELD_CONFIG: Record<ContentType, FieldVisibility> = {
  news: {
    visible: [
      "heading",
      "title",
      "body",
      "blurb",
      "author",
      "image1",
      "image2",
      "socialImage",
      "authorImage",
      "image1Caption",
      "image1Description",
      "image2Description",
      "audio",
      "permalink",
      "tags",
      "tagString",
      "categories",
      "subcategories",
      "isHighPriority",
      "isSecondLeads",
      "onlive",
      "scheduled_at",
      "metaTitle",
      "metaDescription",
      "socialEmbed",
      "embedType",
    ],
    required: ["heading", "body"],
  },
  article: {
    visible: [
      "heading",
      "body",
      "author",
      "image1",
      "image2",
      "authorImage",
      "permalink",
      "tags",
      "tagString",
    ],
    required: ["heading", "body"],
  },
  editorial: {
    visible: [
      "heading",
      "title",
      "body",
      "author",
      "image1",
      "image2",
      "authorImage",
      "image1Description",
      "image2Description",
      "image3Description",
      "audio",
      "permalink",
      "tags",
      "tagString",
      "seriesName",
    ],
    required: ["heading", "body"],
  },
  vidya: {
    visible: [
      "heading",
      "body",
      "author",
      "image1",
      "image2",
      "authorImage",
      "image1Description",
      "image2Description",
      "permalink",
      "tags",
      "scheduled_at",
      "masterid",
    ],
    required: ["heading", "body"],
  },
  njayar: {
    visible: [
      "heading",
      "body",
      "author",
      "image1",
      "image2",
      "authorImage",
      "image1Description",
      "image2Description",
      "permalink",
      "tags",
      "tagString",
      "njayarCategory",
      "isHighPriority",
      "isSecondPriority",
      "isThirdPriority",
      "masterid",
    ],
    required: ["heading", "body"],
  },
};

export const isFieldVisible = (
  contentType: ContentType,
  field: FormField,
): boolean => {
  return FIELD_CONFIG[contentType].visible.includes(field);
};

export const isFieldRequired = (
  contentType: ContentType,
  field: FormField,
): boolean => {
  return FIELD_CONFIG[contentType].required.includes(field);
};
